"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const errors_1 = require("@/common/errors");
const api_1 = require("@/api");
function default_1({ userId, setCompanyRegisterData, onCompanyInfoFetchSuccess, }) {
    return __awaiter(this, void 0, void 0, function* () {
        yield (0, api_1.getData)(`/api/v1/members/${userId}/company-info`)
            .then(res => {
            const { result } = res.data;
            setCompanyRegisterData(result);
            !!onCompanyInfoFetchSuccess && onCompanyInfoFetchSuccess(result);
        })
            .catch(errors_1.handleForbiddenError);
    });
}
exports.default = default_1;
